import * as Accordion from "@radix-ui/react-accordion";
import styled from "styled-components";

export const Header = styled(Accordion.Header)`
    margin: 0;
    padding: 0;
`;
